// @core/api/endpoints/calendar/update_event_template.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  EventTemplateResponse,
  UpdateEventTemplateRequest,
} from '../../../types/calendar';

const BASE_PATH = '/calendar';

/**
 * Update event template
 * Updates an event template's predefined settings.
 */
export async function UpdateEventTemplate(
  template_id: string,
  data: UpdateEventTemplateRequest,
  options?: RequestOptions
): Promise<EventTemplateResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/event-templates/:template_id`;
  requestPath = requestPath.replace(':template_id', encodeURIComponent(template_id));
  const requestOptions = options;
  return client.put<EventTemplateResponse>(requestPath, data, requestOptions);
}
